<script>
    import { createEventDispatcher } from "svelte";
    import InputField from "./InputField.svelte";
    import { _ } from '../services/i18n.js'

    export let fields = [];
    export let buttonLabel = "ui.form.submit";
    export let cancelLabel = "ui.form.cancel";
    export let rawFormData = false;

    $: formFields = fields;
    let form;

    const dispatch = createEventDispatcher();

    function onSubmit(evt) {
        if (rawFormData) {
            dispatch('submit', evt.target);
            return;
        }
        else {
            const formData = new FormData(evt.target);
            const data = Object.fromEntries(formData.entries());
            dispatch('submit', data);
        }
    }

    function onCancel() {
        dispatch('cancel');
    }

    export const setFieldValue = (fieldId, newValue, overwrite) => {
        formFields = fields.map(field => {
            if (field.id === fieldId && (overwrite || !field.value)) {
                field.value = newValue;
            }
            return field;
        });
    }

</script>

<form bind:this={form} on:submit|preventDefault={onSubmit} class="pro-form" >
    {#each formFields as field }
        <InputField type={field.type} bind:value={field.value} name={field.name} id={field.id} label={field.label} required={field.required} placeholder={field.placeholder} on:change={(e) => {
            if (typeof(field.onChanged) === "function") {
                field.onChanged(e);
            }
        }} maxSize={field.maxSize} />
    {/each}
    <slot name="extra-fields"></slot>
    {#if buttonLabel !== ""}
        <button type="submit">{$_(buttonLabel)}</button>
    {/if}
    {#if cancelLabel !== ""}
        <button type="button" on:click={onCancel}>{$_(cancelLabel)}</button>
    {/if}
    <slot></slot>
</form>

<svelte:head>
    <link rel="stylesheet" href="styles/ui/forms.css" />
</svelte:head>
